import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ScienceHero from './components/ScienceHero';
import ScienceNav from './components/ScienceNav';
import GeneticsSection from './components/GeneticsSection';
import SymptomsSection from './components/SymptomsSection';
import DiagnosisSection from './components/DiagnosisSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ReferencesSection from './components/ReferencesSection';

export default function SciencePage() {
  useSEO({
    title: 'CSCF Research & Science | MAP3K7 Genetics, Diagnosis & Case Studies — CSCF Support',
    description:
      'Peer-reviewed research on Cardiospondylocarpofacial syndrome (CSCF): MAP3K7 gene variants, TAK1 signaling, clinical diagnosis criteria, and published case studies from medical literature.',
    keywords:
      'CSCF research, MAP3K7 gene variants, TAK1 kinase, Cardiospondylocarpofacial syndrome genetics, CSCF diagnosis criteria, CSCF case studies, OMIM 157800, CSCF science',
    canonical: 'https://cscfsupport.org/science',
    ogImage: SOCIAL_IMAGE,
    breadcrumbs: [
      { name: 'Home', url: 'https://cscfsupport.org/' },
      { name: 'Research & Science', url: 'https://cscfsupport.org/science' },
    ],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'MedicalWebPage',
      name: 'CSCF Research & Science Overview',
      url: 'https://cscfsupport.org/science',
      description:
        'Comprehensive peer-reviewed research overview of Cardiospondylocarpofacial syndrome including genetics, diagnosis, and published case studies.',
      about: {
        '@type': 'MedicalCondition',
        name: 'Cardiospondylocarpofacial Syndrome',
        alternateName: ['CSCF', 'CSCFS'],
        code: { '@type': 'MedicalCode', code: '157800', codingSystem: 'OMIM' },
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ScienceHero />
      <ScienceNav />
      <GeneticsSection />
      <SymptomsSection />
      <DiagnosisSection />
      <CaseStudiesSection />
      <ReferencesSection />
      <Footer />
    </div>
  );
}
